import React from 'react';
import '../App.css';
import '../style/style.css';
import '../style/sb-admin-2.min.css';
import '../style/perfect-scrollbar.css';
import '../font/css/all.min.css';
import logo from '../img/logos.png';
import user from '../img/user-1.png';
import Sidebar from './sidebar';


const Dashboard =()=> {
    return(
        <div id="wrapper">
        <Sidebar dashboard={"active"}/>
        </div>

    )
};
export default Dashboard;